import { allEventsInSeries } from 'owa-locstrings/lib/strings/alleventsinseries.locstring.json';
import { thisAndAllFollowingEvents } from 'owa-locstrings/lib/strings/thisandallfollowingevents.locstring.json';
import { thisEvent } from 'owa-locstrings/lib/strings/thisevent.locstring.json';
import loc from 'owa-localize';
import EventScope from 'owa-service/lib/contract/EventScope';

import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import type { ViewType } from 'owa-calendar-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import * as CalendarItemCapabilities from 'owa-calendar-event-capabilities';

export default function getDeleteMenuItems(
    calendarEvent: CalendarEvent,
    actionSource: ViewType,
    onDeleteCalendarEventCallback: (eventScope: EventScope, actionSource: ViewType) => void
): IContextualMenuItem[] {
    const isSeriesInstance = CalendarItemCapabilities.isSeriesInstance(calendarEvent);
    const isSeriesMaster = CalendarItemCapabilities.isSeriesMaster(calendarEvent);
    const isFTDFSeriesMaster = CalendarItemCapabilities.isFTDFSeriesMaster(calendarEvent);

    var menuItems = isSeriesInstance
        ? [
              {
                  key: 'delete_occurrence',
                  name: loc(thisEvent),
                  onClick: () => {
                      onDeleteCalendarEventCallback(EventScope.ThisInstanceOnly, actionSource);
                  },
              },
              ...(CalendarItemCapabilities.canActFromThisDateForward(calendarEvent) &&
              calendarEvent.IsOrganizer /* We show delete for events for which we are organizer since we don't support delete this date forward for attendee scenario */
                  ? [
                        {
                            key: 'delete_series_this_instance_forward',
                            name: loc(thisAndAllFollowingEvents),
                            onClick: () => {
                                onDeleteCalendarEventCallback(
                                    EventScope.ThisAndFollowingInstances,
                                    actionSource
                                );
                            },
                        },
                    ]
                  : []),
              {
                  key: 'delete_series_now',
                  name: loc(allEventsInSeries),
                  onClick: () => {
                      onDeleteCalendarEventCallback(EventScope.AllInstancesInSeries, actionSource);
                  },
              },
          ]
        : [
              {
                  key: isSeriesMaster ? 'delete_series_now' : 'delete_occurrence',
                  name: isSeriesMaster ? loc(allEventsInSeries) : loc(thisEvent),
                  onClick: () => {
                      onDeleteCalendarEventCallback(
                          isFTDFSeriesMaster
                              ? EventScope.ThisAndFollowingInstances
                              : EventScope.Default,
                          actionSource
                      );
                  },
              },
          ];

    return menuItems;
}
